module.exports = __webpack_public_path__ + "img/tasks.d05b3269.svg";